import moment from 'moment-timezone';

export const getFormattedDate = (
  date: string,
  userTimezone: string,
  showTime = true,
): string => {
  if (date && userTimezone) {
    const formattedDate = moment.tz(date, userTimezone);

    return `${formattedDate.format('DD MMM')}, ${formattedDate?.format(
      'YYYY',
    )} ${showTime ? formattedDate?.format('hh:mm a').toUpperCase() : ''}`;
  }
  return '';
};
